@if (gameInstance) {
    @if (gameInstance.gameType === GameType.DragonTiger || gameInstance.gameType === GameType.OpenDragonTiger) {
        <app-dragon-tiger-table [data]="gameInstance.view" [isVoid]="isVoid"></app-dragon-tiger-table>
    } @else if (gameInstance.gameType === GameType.Baccarat || gameInstance.gameType === GameType.OpenBaccarat) {
        <app-baccarat-table [data]="gameInstance.view" [isVoid]="isVoid"></app-baccarat-table>
    } @else if (gameInstance.gameType === GameType.ThreeHeadedDragon) {
        <app-three-headed-dragon-table [data]="gameInstance.view" [isVoid]="isVoid"></app-three-headed-dragon-table>
    } @else if (gameInstance.gameType === GameType.Blackjack) {
        <app-blackjack-table [data]="gameInstance.view" [isVoid]="isVoid"></app-blackjack-table>
    }
} @else {
    <h2 i18n class="title-vertical-center title-error">Invalid game data</h2>
}
